import { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { GlobalService } from '../global/global.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HrInterceptorService implements HttpInterceptor {
  constructor(private _global: GlobalService, private _toastr: ToastrService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.includes('login') || req.url.includes('register')) {
      return next.handle(req);
    }
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return next.handle(req).pipe(
      catchError((e: any) => {
        this._global.globalAuthErrorHandler(e.error);
        if (e.statusText == 'Unknown Error') {
          this._toastr.error(
            'Please check your internet connection',
            'An unexpected error occured'
          );
        } else if (e.status == '403' && e.error.responseMessage) {
          this._toastr.error(e.error.responseMessage, 'error');
          window.location.href = `${environment.FRONTEND_HOMEPAGE_URL}/login`;
        }
        //
        // } else if (e.status === '0' || e.status === 0) {
        //   this._global.handleNetworkError();
        //   ;
        // }

        return throwError(e);
      })
    );
  }
}
